import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import OfferStepper from "./stepper/OfferStepper";
import { getOffer } from "../../../../../../services/staffingService";
import DashboardSidebar from "../../../agencyDashboardSidebar";

function OfferStatusStandalone() {
  const { offerId, providerCompanyId, jobId } = useParams();
  const history = useHistory();
  const [offer, setOffer] = useState({});
  const [negotiations, setNegotiations] = useState({});
  const [job, setJob] = useState({});
  const [allOffers, setAllOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [lastUpdated, setLastUpdated] = useState("");
  const [staff, setStaff] = useState({});
  const [showSideDrawer, setShowSideDrawer] = useState(false);

  useEffect(() => {
    fetchOfferData();
  }, [offerId]);

  async function fetchOfferData() {
    setLoading(true);
    try {
      const { data } = await getOffer(providerCompanyId, offerId);
      setOffer(data.offer);
      setNegotiations(data.offer.negotiations);
      setLastUpdated(new Date().toLocaleString());
      setJob(data.job);
      setAllOffers([...data.all_offers]);
      setStaff(data.staff);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching offer data:", error);
      setError("Failed to fetch data");
      setLoading(false);
    }
  }

  const staffName = offer?.provider_resource_id?.user_id
    ? `${offer.provider_resource_id.user_id.firstName} ${offer.provider_resource_id.user_id.lastName}`
    : 'Offer Details';

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 font-inter">
      <DashboardSidebar isOpen={showSideDrawer} setIsOpen={setShowSideDrawer} />
      <main className="flex-1 overflow-y-auto">
        <div className="p-6">

          {/* Back Button — Dispoline pattern */}
          <button
            onClick={() => history.push(`/provider-company/${providerCompanyId}/jobs/${jobId}?tab=offers`)}
            className="mb-6 flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft size={16} />
            Back to Sent Offers
          </button>

          {/* Page Header — Dispoline pattern */}
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-foreground">{staffName}</h2>
            <p className="mt-1 text-sm text-muted-foreground">
              {job?.customer_company_id?.companyName ? `${job.customer_company_id.companyName} · ` : ''}
              Offer status and timeline
            </p>
          </div>

          {/* Loading */}
          {loading && (
            <div className="flex items-center justify-center py-20">
              <div className="bg-white p-6 rounded-xl shadow-lg text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
                <p className="mt-2 text-sm text-muted-foreground">Loading offer details...</p>
              </div>
            </div>
          )}

          {/* Error */}
          {error && (
            <div className="rounded-xl border border-red-200 bg-red-50 p-4">
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}

          {/* Offer Stepper — Dispoline card style */}
          {Object.keys(offer).length > 0 && Object.keys(staff).length > 0 && (
            <div className="overflow-hidden rounded-xl border border-border bg-card shadow-sm">
              <div className="p-6">
                <OfferStepper
                  offer={offer}
                  negotiations={negotiations}
                  setNegotiations={setNegotiations}
                  setOffer={setOffer}
                  offerId={offerId}
                  providerCompanyId={providerCompanyId}
                  jobId={jobId}
                />
              </div>
            </div>
          )}

        </div>
      </main>
    </div>
  );
}

export default OfferStatusStandalone;
